
import {
  getDomElementFromTreeNode,
  getNodeElementWrapperStyles
} from "@/lib/canvas/helpers";
import { findNode } from "@/lib/tree/tree";
import { documentStore, uiStore } from "@/store/store";
import { Component, Vue } from "vue-property-decorator";
import { forceNextTick } from "@/util/force-next-tick";

@Component({})
export default class NodeSingularityContentEditable extends Vue {
  unsubscribeFromStorePositionWrapper = () => {};
  wrapperStyle: { [key: string]: string } = {
    display: "none"
  };
  lastModifiedDomElement: HTMLElement | null = null;

  mounted() {
    this.calculateWrapperStyles();

    this.unsubscribeFromStorePositionWrapper = this.$store.subscribe(
      this.calculateWrapperStyles
    );

    window.addEventListener("resize", this.calculateWrapperStyles);
  }

  beforeDestroy() {
    this.unsubscribeFromStorePositionWrapper();

    window.removeEventListener("resize", this.calculateWrapperStyles);
  }

  get domElement() {
    if (!uiStore.elementWithContentEditable) return null;

    const contentEditableElement = findNode(
      documentStore.document.tree,
      uiStore.elementWithContentEditable
    );

    if (!contentEditableElement) return null;

    const domElement = getDomElementFromTreeNode(contentEditableElement);

    if (domElement?.contentEditable === "true") {
      this.lastModifiedDomElement = domElement;
      return domElement;
    }

    const childWithContentEditable = domElement?.querySelector(
      '[contenteditable="true"]'
    );

    if (childWithContentEditable) {
      this.lastModifiedDomElement = childWithContentEditable as HTMLElement;

      return childWithContentEditable;
    }

    return null;
  }

  calculateWrapperStyles() {
    // wait for the domElement to recalculate
    forceNextTick(() => {
      if (!this.domElement && this.lastModifiedDomElement) {
        this.lastModifiedDomElement.removeEventListener(
          "input",
          this.calculateWrapperStyles
        );
        this.lastModifiedDomElement = null;
      }

      this.wrapperStyle = getNodeElementWrapperStyles(
        this.domElement as HTMLElement
      );

      if (this.domElement) {
        // a contenteditable element won't update the store until it's blurred, but we need to update the wrapper styles
        this.domElement.addEventListener("input", this.calculateWrapperStyles);
      }
    });
  }
}
